import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=aa70a6f2&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=aa70a6f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa70a6f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa70a6f2')) {
      api.createRecord('aa70a6f2', component.options)
    } else {
      api.reload('aa70a6f2', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=aa70a6f2&scoped=true&", function () {
      api.rerender('aa70a6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pH6BLHyLa72U/JS/comp/GuestBoxKids.vue"
export default component.exports